<div id="viewContent" class="content__wrapper partner_content">
  <div id="viewContentData" class="view_partner_data">
    <div id="viewTitle" class="title_bar">
      <img class="page_back_icon" alt="go back" (click)="goBack()" />
      <span class="title">{{contentName}}</span>
    </div>

    <!-- Section 1 - Model SKU Info -->
    <section>
      <div id="viewSectionHeader" class="section_header">
        <img class="sku" alt="sku" />
        <span  i18n = "@@view.header.Model-SKU-Info">MODEL SKU INFO</span>
      </div>
      <div id="viewSectionBody" class="section_body model_info_section">
        <div id="viewSystemId" class="info_group">
          <label><span i18n = "@@view.info-section.systemId">System ID</span></label>
          <span>{{systemID}}</span>
        </div>
        <div id="viewDisplayName" class="info_group" style="max-width: 535px">
          <label><span i18n = "@@view.info-section.displayName">Display Name</span></label>

          <span>
            <ng-container *ngIf="displayVal.length">
              <ng-container *ngFor="let data of displayVal, let i = index, let c = count">
                {{i < c-1 ? (data +  ' - ' + displayLang[i] + ', ') : data +  ' - ' + displayLang[i]}}
              </ng-container>
          </ng-container>
            <ng-container *ngIf="!displayVal.length">
              {{disvalue}} - {{englishLang}}
          </ng-container>
          </span>
        </div>
        <div id="viewParsedData">
          <div id="viewSystemModels" class="info_group">
            <label><span i18n="@@view.info-section.systemModels">System Models</span>
            </label>
          </div>
          <div id="viewSystemData" class="info_group_chip">
            <ng-container *ngIf="!singleData">
              <ng-container *ngFor="let data of parsedData">
                <span class="chip">{{data}}</span>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="singleData">
              <span class="chip">{{parsedData}}</span>
            </ng-container>
          </div>
        </div>
      </div>
      <div id="viewOS" class="boldClass">
        <label><span i18n = "@@view.info-section.os">Operating System</span></label>
        <span>{{operatingSystem}}</span>
      </div>
     
    </section>

    <!-- Section 2 - Language -->
    <section>
      <div id="viewLanguage" class="section_header">
        <img class="lang" alt="" />
        <span i18n = "@@view.info-section.language">LANGUAGE</span>
      </div>
      <div id="viewLangBody" class="section_body">
        <div id="viewLangCat" class="info_group">
          <label><span i18n = "@@view.info-section.category">Language Category</span></label>
          <span>{{languageCategory}}</span>
        </div>
        <div id="viewLanguages" class="info_group">
          <label><span i18n = "@@view.info-section.languages">Languages</span></label>
          <span>{{displayLanguage}}</span>
        </div>
      </div>
    </section>

    <!-- Section 3 - tile thumbnail -->
    <section>
      <div id="viewTileTumbnail" class="section_header">
        <img class="thumbnail" alt="" />
        <span i18n = "@@view.info-section.tilethumbnail">TILE THUMBNAIL</span>
      </div>
      <div id="viewTileImage" class="section_body">
        <img class = "reduceMinHeight" [src]="image" alt="thumbnail" />
      </div>
    </section>

    <!-- Section 4 - Pages -->
    <section>
      <div id="viewPages" class="section_header">
        <img class="page" alt="language" />
        <span i18n = "@@view.info-section.pages">PAGES</span>
      </div>

      <!-- use API page to fill here -->

      <div id="viewPagesView" class="section_body  pages_preview" *ngIf="contentGroupPages.length > 0">
        <iposcen-pages-view [configData]="contentGroupPages" [autoID]="autoID"></iposcen-pages-view>
        
        
      </div>
    </section>

    <!-- Section 5 - Comments -->
    <section *ngIf="hasComments">
      <div id="viewComments" class="section_header">
        <img class="chat_quote" alt="provide comments" />
        <span i18n = "@@view.info-section.comments">COMMENTS</span>
      </div>
      <div id="viewCommentsBody" class="section_body">
        <div id="viewCommentsBodySection" class="comments_provided">
         {{comments}}
        </div>
      </div>
    </section>

    <div id="viewButton" class="button_wrapper" *ngIf="reviewStatus === 'returned'">
      <button class="btn btn-outline-primary btn-lg" (click)="goBack()"><span i18n = "@@view.button.close">Close</span></button>
      <button class="btn btn-primary btn-lg" (click)="goEdit()"><span i18n = "@@view.button.close">Edit</span></button>
    </div>
  </div>
</div>